/* eslint-disable react/prop-types */
import './Searchbar.scss';
import { useId, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faXmark } from '@fortawesome/free-solid-svg-icons';

export default function Searchbar({ onChange, onSubmit, placeholder }) {
  const searchBarId = useId();
  const [value, setValue] = useState('');
  return (
    <div className="xpektor-searchbar">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          if (onSubmit) onSubmit(e);
        }}
        className="search-form"
      >
        <label htmlFor={searchBarId}>Search</label>
        <FontAwesomeIcon className="input-icon" icon={faSearch} />
        <input
          id={searchBarId}
          placeholder={placeholder}
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            if (onChange) onChange(e);
          }}
        />
        {value.length > 0 && (
          <button
            type="button"
            className="clear-icon-button"
            onClick={() => {
              setValue('');
              onChange({ target: { value: '' } });
            }}
          >
            <FontAwesomeIcon className="icon" icon={faXmark} />
          </button>
        )}
      </form>
    </div>
  );
}
